import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups2, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { GROUPS_CREATE, GROUPS_UPDATE, PROVIDER_DELETE_GROUP, resetGroupsState2 } from '../new/group';

const useGroups2 = ({ type, groupId }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.groups.all2);
  const groupsCreate = useSelector(state => state.groups.create);
  const groupsUpdate = useSelector(state => state.groups.update);
  const groupsDelete = useSelector(state => state.groups.delete);

  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request?.type !== type)) {
      dispatch(getGroups2(type));
      return;
    }
    if (groupsCreate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_CREATE));
      dispatch(resetGroupsState2());
    }
    if (groupsUpdate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_UPDATE));
      dispatch(resetGroupsState2());
    }
    if (groupsDelete.status === StateStatus.LOADED) {
      dispatch(resetState(PROVIDER_DELETE_GROUP));
      dispatch(resetGroupsState2());
    }
  }, [data, dispatch, groupsCreate.status, groupsDelete.status, groupsUpdate.status, request, status, type]);

  if (groupId) {
    return { group: (data || []).find(x => x.id === groupId), status, version, entity };
  }

  return { data: data || [], status, version, entity };
};

export default useGroups2;
